









































import {Component, Prop, Vue} from "vue-property-decorator";
import {DeviceCommandParams, DownlinkItem} from "@/services/CoreClient";
import {curGroupService} from "@/services/GroupService";
import TimestampAgo from "@/components/TimestampAgo.vue";

@Component({
  components: {
    TimestampAgo,
  }
})
export default class GroupDownlinksQueueSection extends Vue {
  @Prop({ default: () => '', type: String}) group!:string;
  @Prop({ default: () => {}, type: Object}) bus!:Vue;

  downlinks:DownlinkItem[] = [];
  error:string = '';

  async mounted() {
    this.bus.$on('refresh', async () => {
      this.downlinks = await this.loadDownlinksQueue(this.group);
    });
    this.downlinks = await this.loadDownlinksQueue(this.group);
  }

  async loadDownlinksQueue(groupId:string):Promise<DownlinkItem[]> {
    try {
      return  await curGroupService.fetchDownlinksQueue({
        groupId,
      }) as DownlinkItem[];
    } catch (err) {
      this.error = (err as Error).message;
      return [];
    }
  }
}
